import axios from 'axios';
import errorMessage from './errorMessage';
import ProjectConfig from 'ProjectConfig';

const API_GATEWAY = ProjectConfig.API_GATEWAY;

export const getReportedJockeys = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await axios.get(`${API_GATEWAY}/mobile/tjk/reportedJockey`);
      resolve(res);
    } catch (e) {
      const error = e.response?.data;
      reject(error || errorMessage);
    }
  });
};

export const getSuspendedJockeys = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await axios.get(`${API_GATEWAY}/mobile/tjk/suspendedJockey`);
      resolve(res);
    } catch (e) {
      const error = e.response?.data;
      reject(error || errorMessage);
    }
  });
};
